// The comparable form of a hostname, and the one place it is declared.
//
// It is read from three sides now and they must not be allowed to drift: the
// model normalizes what a person typed before it validates and writes it, the
// public renderer normalizes what arrived in the path before it looks a row up,
// and `cdn/origin-request`'s file proxy does the same at the edge. The host is
// this table's WHOLE primary key (see `host` in ./fields), so two spellings of
// one name are two rows and two claims — which is the collision the table
// exists to refuse.
export const normalizeHost = (value) =>
  String(value === undefined || value === null ? "" : value)
    .trim()
    .toLowerCase()
    // A trailing dot is a legal, fully-qualified way to write a hostname and is
    // NOT how it arrives in a Host header, so it would be a second key for one
    // name. Stripped rather than rejected.
    .replace(/\.$/, "");
